// ══════════════════════════════════════════════════════════════════════════════════════════════
//  DOCUMENTOS PARA VALIDAR: el aviso de arriba y el enlace «Mándaselo a soporte»   (4-oct-2026, t83)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  El dueño (4-oct): «es soporte quien lo sube y la clínica lo valida», con «arriba del todo en modo admin un mensaje tipo
//  "ya se han volcado tus documentos, necesitas validar los tratamientos"», y que la clínica no suba nada: si tiene un
//  baremo o un inventario, se lo manda a soporte.
//   · `AvisoDocumentosPorValidar({ pendientes, ir })`: el aviso del panel de administración (components/AdminLayout.jsx,
//     arriba del todo) y del Almacén (pages/Stock.jsx). `pendientes` = lo que contesta GET /api/importar-documentos/
//     pendientes ({ tarifas: n, almacen: n }, solo de lo que esa persona puede validar); sin nada pendiente no pinta nada.
//   · `EnlaceMandarASoporte({ que })`: abre una consulta nueva con el soporte (el globo de ayuda, components/ChatWidget.jsx,
//     evento «biango:mandar-a-soporte») con el texto ya puesto, para adjuntar el fichero.
//  SIN HOOKS NI IMPORTS, A PROPÓSITO (como utils/contactoBiango.jsx): el panel lo pintan decenas de guardias con sus dobles,
//  y un `utils/` sin dependencias se carga de verdad en todas sin tocar ninguna (@pintarJsx-con-react). Los datos los pide
//  quien lo monta. Y NO NOMBRA LA IA: lo lee la clínica (backend/routes/importar-documentos-validacion.test.js).

import { t } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const TXT_POR_VALIDAR = {
  get tarifas() { return t('utils.documentosPorValidar.ya_se_han_volcado_tus', 'Ya se han volcado tus documentos: necesitas validar los tratamientos.') },
  get almacen() { return t('utils.documentosPorValidar.ya_se_han_volcado_tus_2', 'Ya se han volcado tus documentos: necesitas validar los productos del almacén.') },
  get validar() { return t('utils.documentosPorValidar.validar_ahora', 'Validar ahora') },
  mandar: {
    get tarifas() { return t('utils.documentosPorValidar.tienes_el_baremo_de_una', '¿Tienes el baremo de una aseguradora? Mándaselo a soporte') },
    get almacen() { return t('utils.documentosPorValidar.tienes_un_inventario_o_un', '¿Tienes un inventario o un albarán? Mándaselo a soporte') },
  },
  textoConsulta: {
    tarifas: 'Hola. Os adjunto el baremo de una aseguradora para que lo volquéis en nuestras tarifas. La aseguradora y el producto (o la tarifa) son: ',
    almacen: 'Hola. Os adjunto nuestro inventario (o un albarán) para que lo volquéis en el almacén. ',
  },
}

const cuenta = (v) => (typeof v === 'number' && v > 0 ? v : 0)

export default function AvisoDocumentosPorValidar({ pendientes, ir }) {
  if (!pendientes || typeof pendientes !== 'object') return null
  const usos = ['tarifas', 'almacen'].filter((u) => cuenta(pendientes[u]) > 0)
  if (!usos.length) return null
  return (
    <div data-documentos-por-validar="" role="status" style={{ display: 'flex', flexDirection: 'column', gap: '6px', padding: '10px 16px', background: 'color-mix(in srgb, var(--warning) 12%, var(--surface))', borderBottom: '1px solid color-mix(in srgb, var(--warning) 35%, var(--border))' }}>
      {usos.map((u) => (
        <div key={u} data-por-validar={u} style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', fontSize: '13px' }}>
          <strong style={{ flex: '1 1 260px' }}>{TXT_POR_VALIDAR[u]}{cuenta(pendientes[u]) > 1 ? ' (' + pendientes[u] + ')' : ''}</strong>
          <button type="button" className="btn btn-primary" onClick={() => { if (typeof ir === 'function') ir(u) }} style={{ padding: '6px 12px', fontSize: '13px' }}>{TXT_POR_VALIDAR.validar}</button>
        </div>
      ))}
    </div>
  )
}

export function EnlaceMandarASoporte({ que = 'tarifas', style }) {
  const abrir = () => {
    try { window.dispatchEvent(new CustomEvent('biango:mandar-a-soporte', { detail: { texto: TXT_POR_VALIDAR.textoConsulta[que] || '' } })) } catch (_) { /* sin ventana */ }
  }
  return (
    <button type="button" data-mandar-a-soporte={que} onClick={abrir}
      style={{ background: 'none', border: 0, padding: 0, color: 'var(--primary)', fontSize: '12.5px', cursor: 'pointer', textDecoration: 'underline', textAlign: 'left', ...(style || {}) }}>
      {TXT_POR_VALIDAR.mandar[que] || TXT_POR_VALIDAR.mandar.tarifas}
    </button>
  )
}
